// extracted by mini-css-extract-plugin
export var footer = "_pa-0";
export var inherit = "_pa-1";
export var input = "_pa-2";
export var modalContent = "_pa-3";
export var quillEditor = "_pa-4";
export var subtitle = "_pa-5";